import { FC } from 'react';
import { merge } from '../../helpers/Utility';
import { withField } from '../form/withField';

interface radioGroupItem {
  key: string | number;
  value: string;
  description?: string;
  label?: string;
  className?: string;
}

interface InjectedProps {
  value: string;
  onChange: (value: string) => void;
}

interface RadioGroupProps {
  name: string;
  items?: radioGroupItem[];
  fieldSetClasses?: string;
  labelClasses?: string;
  noOptionsString?: string;
}

export const RadioGroup: FC<RadioGroupProps & InjectedProps> = ({
  name,
  items,
  value,
  fieldSetClasses,
  onChange,
  noOptionsString,
  labelClasses
}) => {
  return (
    <fieldset className={fieldSetClasses || ''} id={name}>
      {items && items.length ? (
        items.map((item: radioGroupItem) => {
          const { key, description, label, value: itemValue } = item;

          return (
            <div className="flex flex-grow min-w-[33%] md:px-2 md:py-2">
              <label key={`${name}-${key}`} className={`${labelClasses ? labelClasses : ''} flex w-full p-4 space-x-2`}>
                <input
                  className={merge(item.className, 'rounded-md')}
                  type="radio"
                  onChange={() => onChange(itemValue)}
                  checked={value === itemValue}
                  value={itemValue}
                  name={itemValue}
                />
                <div className="flex flex-col leading-4">
                  {label && <span className="font-medium">{label}</span>}
                  {description && <span className="text-sm text-gray-500">{description}</span>}
                </div>
              </label>
            </div>
          );
        })
      ) : (
        <p className="text-red-500">{noOptionsString}</p>
      )}
    </fieldset>
  );
};

export const RadioGroupField = withField<string, RadioGroupProps>(RadioGroup);
